module.exports = __webpack_public_path__ + "static/media/image13.ae6df693.png";